// The brand themes reference the custom font families "wbs-Source-Sans-3" and
// "wbs-GeneralSans". Their @font-face rules live in src/index.css, which is only
// loaded by the standalone app entry (src/index.tsx) — NOT by the library build.
// When the widget is consumed as an npm package the families would be undefined
// and the browser falls back to a default font.
//
// To keep the library self-contained (consistent with the rest of the styling,
// which is injected at runtime via CSS-in-JS), we inject the @font-face rules
// here. The .woff2 files are inlined as base64 data URLs by Vite
// (assetsInlineLimit: Infinity), so no separate font files have to be served.
// woff2 is supported by every browser in the project's browserslist, so the
// legacy woff/ttf fallbacks from index.css are intentionally omitted.
import sourceSans3Regular from "../assets/fonts/source-sans-3-v9-latin-regular.woff2";
import generalSansSemibold from "../assets/fonts/GeneralSans-Semibold.woff2";

const STYLE_ELEMENT_ID = "wbs-genesys-chatbot-fonts";

export function injectFonts(): void {
  if (typeof document === "undefined") {
    return;
  }

  // Idempotent — multiple mounts (or React StrictMode double-invoke) inject once.
  if (document.getElementById(STYLE_ELEMENT_ID)) {
    return;
  }

  const style = document.createElement("style");
  style.id = STYLE_ELEMENT_ID;
  style.textContent = `
    @font-face {
      font-family: "wbs-Source-Sans-3";
      src: url("${sourceSans3Regular}") format("woff2");
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: "wbs-GeneralSans";
      src: url("${generalSansSemibold}") format("woff2");
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `;

  document.head.appendChild(style);
}
